// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"iw_a bht_je","CommentListPlaceholder--Legacy":"iw_b bht_qh bht_vk"};